import React from "react";
import { Text, Card, Stack, Badge, Flex } from "@mantine/core";
import { LoyaltyMembershipCheck } from "./";

export default function LoyaltyMembershipItem({ membership, fetchData }) {
  return (
    <Card>
      <Stack gap={2} mb="lg">
        <Flex gap="xs" align="center">
          <Text fw={700} size="lg">
            {membership.ident}
          </Text>
          <Badge size="xs" color="gray" variant="light">
            {membership.variety_formatted}
          </Badge>
        </Flex>
        <Text style={{ textTransform: "capitalize" }}>
          {membership.status_formatted}
        </Text>
        <Text c={membership.confirmed_by_third_party_api ? "dark" : "red"}>
          {membership.confirmed_by_third_party_api
            ? "Confirmed by third party API"
            : "Unconfirmed by third party API"}
        </Text>
        <Text>
          Initial activation:{" "}
          {new Date(membership.initial_activation_date).toLocaleDateString()}
        </Text>
        <Text>
          Last verified:{" "}
          {new Date(membership.last_verified_at).toLocaleDateString()}
        </Text>
      </Stack>
      <LoyaltyMembershipCheck
        reqData={{
          loyalty_membership_id: membership.id,
          variety: membership.variety,
        }}
        fetchData={() => {
          fetchData();
        }}
      />
    </Card>
  );
}
